import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearUser } from "../../redux/slices/userSlice";
import { loggedOut } from "../../service/auth.service";
import { LogOut, Lock } from "lucide-react";

const UnauthorizedAccess = ({ onLogout }) => (
  <div className="flex justify-center items-center h-screen bg-gray-50">
    <div className="flex flex-col items-center p-8 bg-white rounded-lg shadow-lg space-y-6">
      <div className="flex items-center space-x-2">
        <Lock className="h-8 w-8 text-red-500" />
        <h1 className="text-red-500 font-bold text-xl text-center">
          Vous n'êtes pas autorisé à accéder à cette page
        </h1>
      </div>
      
      <p className="text-gray-600 text-center">
        Veuillez vous déconnecter et vous reconnecter avec un compte autorisé.
      </p>
      
      <button 
        className="flex items-center justify-center space-x-2 p-3 w-full rounded-md bg-indigo-50 border-2 border-indigo-600 hover:bg-indigo-100 transition duration-300 ease-in-out"
        onClick={onLogout}
      >
        <LogOut className="h-6 w-6 text-indigo-600" />
        <span className="text-indigo-600 font-semibold">Se déconnecter</span>
      </button>
    </div>
  </div>
);

const ProtectedRoutes = ({ children, allowedRoles }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const userRole = useSelector((state) => 
    state.user.userRole ? state.user.userRole.name : null
  );

  const handleLogout = () => {
    dispatch(clearUser());
    loggedOut();
    navigate("/login");
  };

  // Redirect to login if no role is present
  if (userRole === null) {
    handleLogout();
    return null;
  }

  // Return children if user has permission, otherwise show unauthorized message
  return allowedRoles.includes(userRole) ? (
    children
  ) : (
    <UnauthorizedAccess onLogout={handleLogout} />
  );
};

export default ProtectedRoutes;